import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";

export default async function submitFeedback(
  interactionKey: string,
  feedbackType: string
): Promise<Throwable<Response>> {
  // URL: aipeBaseUrl/productbot/savefeedback
  // body:
  //  'interactionKey': string, from the original answer request
  //  'feedbackType': string, positive or negative
  const url = new URL(`/chatbot/feedback`, window.location.origin);
  try {
    const response = await fetch(url.href, {
      method: "POST",
      body: JSON.stringify({ interactionKey, feedbackType }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      return {
        isError: true,
        error: new Error(response.statusText),
      };
    }
    return { isError: false, value: response };
  } catch (error) {
    return { isError: true, error: toError(error) };
  }
}
